export enum DateReferences {
    FolderCreation = 0,
    LastFolderUpdate = 1,
    WorkflowStepStart = 2,
    WorkflowStateStart = 3,
    DateAttribute = 4,
}
